import { httpCommonAuth } from "../http.service";

const API_PATH = "/files";

export const downloadFile = (fileName) => {
  return httpCommonAuth.get(`${API_PATH}/download/${fileName}`, {
    responseType: "arraybuffer",
  });
};

export const uploadFileAxios = (formData, fileId) => {
  return httpCommonAuth.post(`${API_PATH}/uploadfile/${fileId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadFile = (formData) => {
  return httpCommonAuth.post(API_PATH, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deletePublicRegistrationFile = (storageKey) => {
  return httpCommonAuth.delete(`${API_PATH}/public-registration`, {
    data: { storageKey },
  });
};

export const uploadTenantLogoAxios = (formData) => {
  return httpCommonAuth.post("tenant/upload-logo", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const downloadRegistrationPdf = (contractId) => {
  return httpCommonAuth.get(`/contract/${contractId}/registration-pdf`, {
    responseType: "arraybuffer",
  });
};
